export default __webpack_public_path__ + "static/media/bookwhite.495781f1.svg";